import { FONTS } from '../fonts.js';

export function getFontName(fontFamily) {
  const font = FONTS.find(font => font.name === fontFamily);

  const name = font.displayName || font.name;

  return name;
}
